import { ProxyInstanceSettings } from 'types/interfaces';

export const initProxySettings: ProxyInstanceSettings = {
  PlatformInstanceId: '',
  hostname: '',
  features: {
    address_lookup: true,
    afs_cribsheets: true,
    afs_legacydealviewer: false,
    audit: false,
    calculator: true,
    chatter: true,
    marketing: true,
    fca: true,
    redflag: true,
    rfgql: false,
    storage: true,
    test_flight: false,
    vrm: true,
    message_hub: true,
    bips_weekly: false,
    noticeboard_instance: true,
    dashboard: true,
    deal: true,
    data: true,
    extreme_caution: true,
    faq: true
  }
};
